module.exports = __webpack_public_path__ + "img/p3_1.5b77595a.png";